import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useLoading } from "./LoadingContext";

function Footer() {
  const { loading } = useLoading();
  const location = useLocation(); // Get current route

  // Define a variable to store the footer styles based on the route
  const isDashboard =
    location.pathname === "/jd_dashboard" ||
    location.pathname === "/signup" ||
    location.pathname.includes("/admin_login") ||
    location.pathname.includes("/login") ||
    location.pathname === "/user_dashboard" ||
    location.pathname === "/client_dashboard" ||
    location.pathname === "/reports_dashboard" ||
    location.pathname === "/matched_results" ||
    location.pathname === "/summary_report" ||
    location.pathname === "/employee_dashboard" ||
    location.pathname.includes("/onboarding_form/") ||
    location.pathname.includes("/verification_form/") ||
    location.pathname.includes("/candidate_form/") ||
    location.pathname === "/jdform" ||
    location.pathname.includes("/add_jd") ||
    location.pathname.includes("/edit") ||
    location.pathname.includes("/add_user_copy") ||
    location.pathname.includes("/edit_user") ||
    location.pathname.includes("/add_client") ||
    location.pathname.includes("/add_client_copy") ||
    location.pathname.includes("/edit_client") ||
    location.pathname === "/add_user" ||
    location.pathname.includes("/recruiter_performance") ||
    location.pathname.includes("/jd_performance") ||
    location.pathname.includes("/recruiter_ranking_dashboard") ||
    location.pathname.includes("/selection_page");

  if (loading) return null; // Hide footer when loading

  return (
    <div>
      {/* <footer className="dashboard-footer text-white sticky-bottom"> */}
      <footer
        className={` text-white sticky-bottom ${
          isDashboard ? "dashboard-footer" : "footer text-white"
        }`}
      >
        <div className="container">
          <div className="row justify-content-between align-items-center">
            <div className="col-lg-6 col-md-12 text-lg-start text-center mb-2 mb-lg-0">
              <p className="mb-0">
                © Copyright {new Date().getFullYear()} Archipel Technlogies Pvt
                Ltd. . All Rights Reserved.
              </p>
            </div>
            <div className="col-lg-6 col-md-12 text-lg-end text-center">
              <Link
                to="https://www.archipeltechnologies.com/privacy-policy/"
                className=" me-3"
              >
                Privacy & Cookies
              </Link>
              <Link
                to="https://www.archipeltechnologies.com/terms-and-conditions/"
                className=""
              >
                Terms of Use
              </Link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Footer;
